import { WprBaseScopeViewInfo } from '../../wpr-framework/view/WprBaseScopeViewInfo';
import { WprBaseScopeInfo } from '../../wpr-framework/scope/WprBaseScopeInfo';
import { postUtagView } from '../../../public/utag';
import { VIEW_DEFINE_JSON, ROOT_TITLE } from '../../common/viewDefine';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { ErrorInfo } from '../../models/ErrorInfo';
import { WprBaseViewCore } from '../../wpr-framework/view/WprBaseViewCore';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import SelectPaymentComponent from '../select-payment/SelectPaymentComponent';

/**
* スコープビュー基本情報
*/
export class BaseWindowViewScope<T extends WprBaseScopeInfo> extends WprBaseScopeViewInfo<T> {
	// private 変数		---------------------------------------------------------
	private m_UtagView: any 		= null;		//　UtagView情報
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** UtagView情報 */
	public get utagView(): any { return this.m_UtagView; }
	// --------------------------------------------------------------------------

	// モデル -------------------------------------------------------------------
	@WprDI_GlobalScopeModel('ErrorInfo')
	public m_ErrorInfo: ErrorInfo 	= null;		// エラーメッセージ
	// --------------------------------------------------------------------------
	
	// コンストラクタ  -----------------------------------------------------------
	/** ビュー名称 */
	public constructor(name: string) { super(name); }
	// --------------------------------------------------------------------------
	
	// override メソッド  --------------------------------------------------------
	/**
	* コントロール定義設定
	*/
	public onRegisterConfig(): void {}

	public onDisableClickOnInputElements(): void {}

	/**
	* アクション登録
	*/
	public onRegisterAction(): void {
		this.addAction('prev', this.onPrev);
	}

	/**
	* ビュー表示通知
	*/
	public onShowView(): void {
		// if (this.name !== '') {
		// 	const utagView = VIEW_DEFINE_JSON.find((view) => {
		// 		return (view.virtualPage === '/'+this.name);
		// 	});
		// if (utagView !== null) {
		// 	this.m_UtagView = utagView;
		// if (utagView.extraFlg === true) 	
		// 	this.onExtraUtagView(utagView);
		// postUtagView(utagView, this.productCode);
		// 	}
		// }
		this.refreshView();
	}

	/**
	 * tealium tag 設定処理
	 */
	public onUtagView(): void {
		try {
			if (this.name !== '') {
				const utagView = VIEW_DEFINE_JSON.find((view) => {
					return (view.virtualPage === '/'+this.name);
				});
				if (utagView !== null) {
					this.m_UtagView = utagView;
					if (this.m_UtagView.extraFlg === true) 	
						this.onExtraUtagView(this.m_UtagView);
					postUtagView(this.m_UtagView, this.productCode);
				}
			}
		} catch (e) {
			console.log('postUtagView failed. Retring...');
			const maxRetryCnt: number = 10;
			let retryCnt: number = 0;
			const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
			(async () => {
				while (retryCnt < maxRetryCnt) {
					await sleep(1);
					try {
						console.log('retry:' + (retryCnt + 1));
						postUtagView(this.m_UtagView, this.productCode);
						retryCnt = maxRetryCnt;
					} catch (e) {
						retryCnt++;
					}
				}
			})();
		}
	}
	public onUtagView2(): boolean {
		try {
			if (this.name !== '') {
				const utagView = VIEW_DEFINE_JSON.find((view) => {
					return (view.virtualPage === '/'+this.name);
				});
				if (utagView !== null) {
					this.m_UtagView = utagView;
					if (this.m_UtagView.extraFlg === true) 	
						this.onExtraUtagView(this.m_UtagView);
					postUtagView(this.m_UtagView, this.productCode);
				}
			}
			return true;
		} catch (e) {
			return false;
		}
	}

	public onUtagViewWithEventOff(idList: string[]): void {
		console.log('postUtagView failed. Retring...');
		if (this.name !== '') {
			const utagView = VIEW_DEFINE_JSON.find((view) => {
				return (view.virtualPage === '/'+this.name);
			});
			if (utagView !== null) {
				this.m_UtagView = utagView;
				if (this.m_UtagView.extraFlg === true) 	
					this.onExtraUtagView(this.m_UtagView);
				try {
					postUtagView(this.m_UtagView, this.productCode);
				} catch (error) {
					console.log('postUtagView failed. Retring Again...');
					const maxRetryCnt: number = 10;
					let retryCnt: number = 0;
					const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
					(async () => {
						while (retryCnt < maxRetryCnt) {
							await sleep(1);
							try {
								console.log('retry:' + (retryCnt + 1));
								postUtagView(this.m_UtagView, this.productCode);
								retryCnt = maxRetryCnt;
							} catch (e) {
								retryCnt++;
							}
						}
						await sleep(5);
						let existsEvent = false;
						while (existsEvent == false) {
							// jQueryで各要素IDのイベント取得
							if ($._data($(idList[0]).get(0), 'events'))
								existsEvent = true;
							await sleep(1);
						}
						for (let id of idList) {
							// jQueryでclickイベントオフ（pageview抑制のため）
							$(id).off('click');
						}
					})();
				}
			}
		}
	}

	/**
	* ドキュメントタイトル取得
	* @returns ドキュメントタイトル
	*/
	public getDocumentTitle() : string {
		if (this.name !== '') {
			const viewDefine = VIEW_DEFINE_JSON.find((view) => {
				return (view.virtualPage === '/'+this.name);
			});
			if (viewDefine) {
				return viewDefine.title+ROOT_TITLE;
			}
			// if (utagView) {
			// 	if (utagView !== null) {
			// 		return utagView.title+ROOT_TITLE;
			// 	}
			// }
		}
		return null;
	}

	/**
	* 商品コード取得
	*/
	public get productCode(): string { 
		return ''; 
	}

	/**
	* サービスエラー通知処理
	* @param url URL
	* @param status ステータス
	* @param message エラーメッセージ 
	* @param error エラー情報
	*/
	public onServiceError(url: string, status: string, message: string, error?: Error): void {
		this.m_ErrorInfo = new ErrorInfo();
		this.m_ErrorInfo.message = message;
		console.log('Serviceエラー');
		this.setGlobalScopeModel('ErrorInfo', this.m_ErrorInfo);
		this.pushPath('/error');
	}

	/**
	* サービスエラー通知処理
	* @param url URL
	* @param status ステータス
	* @param message エラーメッセージ 
	* @param error エラー情報
	*/
	public onViewError(message?: string): void {
		if (!message)
			message = 'システムエラーが発生しました。恐れ入りますが、最初からやり直してください。';
		this.m_ErrorInfo = new ErrorInfo();
		this.m_ErrorInfo.message = message;
		console.log('Viewエラー:リロード・更新');
		this.setGlobalScopeModel('ErrorInfo', this.m_ErrorInfo);
		this.pushPath('/error');
	}


	/**
	* 戻る処理
	*/
	public onPrev(param: any): void {
		this.goBack();
	}

	/**
	* Tealium Utag View　追加処理
	*/
	public onExtraUtagView(utagView: any): void {}

	/**
	* 数値 -> 日本円単位変換処理
	* @param amount 
	*/
	public toJPUnit(amount: string): string {
		if (amount.includes('円'))
			return amount;
		const _string = amount;
		const _length = _string.length;
		const _digits = ['', '万', '億', '兆', '京', '垓'];
		let _result = '';
		let _results = [];
		for(let i=0; i<Math.ceil(_length / 4); i++){
			_results[i] = Number(_string.substring(_length - i * 4, _length - (i + 1) * 4));
			if(_results[i] != 0) 
				_result = String(_results[i]).replace(/(\d)(?=(\d\d\d)+$)/g, '$1,') + _digits[i] + _result;
		}
		return _result + '円';
	}

	public onPreventClickEvent(viewCore: WprBaseViewCore, name: string) {
		// const control: WprControlInfo = viewCore.getControlInfo(name);
		// const element: any = $(`input[name='${name}']`);
		// if (element.length > 1) {
		// 	for (let i: number = 0; i < element.length; i++) {
		// 		element[i].click(function (event) {
		// 			event.stopImmediatePropagation();
		// 		});
		// 		if (element[i].type === 'radio')
		// 			element[i].checked = false;
		// 	}
		// }
		// else {
		// 	element.click(function (event) {
		// 		event.stopImmediatePropagation();
		// 	});
		// }
	}
	// --------------------------------------------------------------------------

}
